var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4267",
    "data-name": "Grupo 4267",
    transform: "translate(-695.501 -276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4190",
    "data-name": "Grupo 4190",
    transform: "translate(695.615 275.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_60",
    "data-name": "Elipse 60",
    transform: "translate(-0.115 26.001) rotate(-90)",
    fill: "none",
    stroke: "#00a2e0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4191",
    "data-name": "Grupo 4191",
    transform: "translate(701.609 287.252)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_213",
    "data-name": "Elipse 213",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-1.109 -0.252)",
    fill: "#00a2e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_214",
    "data-name": "Elipse 214",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(4.891 -0.252)",
    fill: "#00a2e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_215",
    "data-name": "Elipse 215",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(10.891 -0.252)",
    fill: "#00a2e0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndamento);
export default __webpack_public_path__ + "static/media/Andamento.877a3484.svg";
export { ForwardRef as ReactComponent };